import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
function createAsyncInterruptHook() {
  var callbacks = [];
  var tap = function(cb) {
    callbacks.push(cb);
  };
  var call = function() {
    var _ref = _async_to_generator(function() {
      var _len, params, _key, interrupted, interruptResult, interrupt, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, callback, result, err;
      var _arguments = arguments;
      return _ts_generator(this, function(_state) {
        switch (_state.label) {
          case 0:
            for (_len = _arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
              params[_key] = _arguments[_key];
            }
            interrupted = false;
            interrupt = function(info) {
              interrupted = true;
              interruptResult = info;
            };
            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
            _state.label = 1;
          case 1:
            _state.trys.push([
              1,
              6,
              7,
              8
            ]);
            _iterator = callbacks[Symbol.iterator]();
            _state.label = 2;
          case 2:
            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done))
              return [
                3,
                5
              ];
            callback = _step.value;
            if (interrupted)
              return [
                3,
                5
              ];
            return [
              4,
              callback.apply(void 0, _to_consumable_array(params).concat([
                interrupt
              ]))
            ];
          case 3:
            result = _state.sent();
            if (result !== void 0) {
              params[0] = result;
            }
            _state.label = 4;
          case 4:
            _iteratorNormalCompletion = true;
            return [
              3,
              2
            ];
          case 5:
            return [
              3,
              8
            ];
          case 6:
            err = _state.sent();
            _didIteratorError = true;
            _iteratorError = err;
            return [
              3,
              8
            ];
          case 7:
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
            return [
              7
            ];
          case 8:
            return [
              2,
              interrupted ? interruptResult : params[0] || []
            ];
        }
      });
    });
    return function call2() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    tap,
    call
  };
}
function createSyncHook() {
  var callbacks = [];
  var tap = function(cb) {
    callbacks.push(cb);
  };
  var call = function() {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
    try {
      for (var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var callback = _step.value;
        var result = callback.apply(void 0, _to_consumable_array(params));
        if (result !== void 0) {
          params[0] = result;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
    return params[0];
  };
  return {
    tap,
    call
  };
}
function createAsyncHook() {
  var callbacks = [];
  var tap = function(cb) {
    callbacks.push(cb);
  };
  var call = function() {
    var _ref = _async_to_generator(function() {
      var _len, params, _key, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, callback, result, err;
      var _arguments = arguments;
      return _ts_generator(this, function(_state) {
        switch (_state.label) {
          case 0:
            for (_len = _arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
              params[_key] = _arguments[_key];
            }
            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
            _state.label = 1;
          case 1:
            _state.trys.push([
              1,
              6,
              7,
              8
            ]);
            _iterator = callbacks[Symbol.iterator]();
            _state.label = 2;
          case 2:
            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done))
              return [
                3,
                5
              ];
            callback = _step.value;
            return [
              4,
              callback.apply(void 0, _to_consumable_array(params))
            ];
          case 3:
            result = _state.sent();
            if (result !== void 0) {
              params[0] = result;
            }
            _state.label = 4;
          case 4:
            _iteratorNormalCompletion = true;
            return [
              3,
              2
            ];
          case 5:
            return [
              3,
              8
            ];
          case 6:
            err = _state.sent();
            _didIteratorError = true;
            _iteratorError = err;
            return [
              3,
              8
            ];
          case 7:
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
            return [
              7
            ];
          case 8:
            return [
              2,
              params[0] || []
            ];
        }
      });
    });
    return function call2() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    tap,
    call
  };
}
function createCollectAsyncHook() {
  var callbacks = [];
  var tap = function(cb) {
    callbacks.push(cb);
  };
  var call = function() {
    var _ref = _async_to_generator(function() {
      var _len, params, _key, results, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, callback, result, err;
      var _arguments = arguments;
      return _ts_generator(this, function(_state) {
        switch (_state.label) {
          case 0:
            for (_len = _arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
              params[_key] = _arguments[_key];
            }
            results = [];
            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
            _state.label = 1;
          case 1:
            _state.trys.push([
              1,
              6,
              7,
              8
            ]);
            _iterator = callbacks[Symbol.iterator]();
            _state.label = 2;
          case 2:
            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done))
              return [
                3,
                5
              ];
            callback = _step.value;
            return [
              4,
              callback(params)
            ];
          case 3:
            result = _state.sent();
            if (result !== void 0) {
              results.push(result);
            }
            _state.label = 4;
          case 4:
            _iteratorNormalCompletion = true;
            return [
              3,
              2
            ];
          case 5:
            return [
              3,
              8
            ];
          case 6:
            err = _state.sent();
            _didIteratorError = true;
            _iteratorError = err;
            return [
              3,
              8
            ];
          case 7:
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
            return [
              7
            ];
          case 8:
            return [
              2,
              results
            ];
        }
      });
    });
    return function call2() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    tap,
    call
  };
}
function createCollectSyncHook() {
  var callbacks = [];
  var tap = function(cb) {
    callbacks.push(cb);
  };
  var call = function() {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    var results = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
    try {
      for (var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var callback = _step.value;
        var result = callback(params);
        if (result !== void 0) {
          results.push(result);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
    return results;
  };
  return {
    tap,
    call
  };
}
export {
  createAsyncHook,
  createAsyncInterruptHook,
  createCollectAsyncHook,
  createCollectSyncHook,
  createSyncHook
};
